export default ".VIP_LoginPage__loginCard {\n  border:        8px solid black;\n  border-radius: 1em;\n  position:relative;\n  overflow:visible;\n}\n\n.VIP_LoginPage__loginCard:after {\n  content:   'Hi from Concept Board';\n  position:  absolute;\n  font-size: 22px;\n  font-weight:500;\n  text-decoration: underline;\n  color: #4184f3;\n\n  top:    8px;\n  width:100%;\n  text-align: center;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader/dist/cjs.js!./src/stores/catalog/flexLayout/flexComponents/content-panels/BuyingBoardOverrides.css
// module id = 1127
// module chunks = 10